/* eslint-disable linebreak-style */
import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { getIn, FormikProps } from 'formik';

type TextFieldInput = {
  formikProps: FormikProps<any>
  fieldName: string,
  visibleName: string,
  showLabel?: boolean
  showAsTextarea?: boolean
  extraClassValues?: string,
  placeholder?: string,
  formText?: string,
  onChangeCallback?:
    (
      val: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    ) => void,
  isPairedInput?: boolean,
}
const TextField: React.FC<TextFieldInput> = (
  props: TextFieldInput,
): ReactElement => {
  const {
    fieldName,
    visibleName,
    extraClassValues = '',
    showLabel = true,
    showAsTextarea = false,
    onChangeCallback,
    formikProps,
    isPairedInput = false,
  } = props;
  const {
    placeholder = visibleName,
    formText = '',
  } = props;
  const {
    handleBlur,
    values,
    touched,
    errors,
    handleChange,
  } = formikProps;
  const labelElement = showLabel && <Form.Label>{visibleName}</Form.Label>;
  const asTextarea = showAsTextarea ? 'textarea' : 'input';
  const isInvalid = isPairedInput
    ? getIn(errors, fieldName)
    : getIn(touched, fieldName) && getIn(errors, fieldName);

  return (
    <Form.Group controlId={fieldName} className={extraClassValues}>
      {labelElement}
      <Form.Control
        aria-label={visibleName}
        placeholder={placeholder}
        value={getIn(values, fieldName) || ''}
        isInvalid={isInvalid}
        onChange={(e) => {
          handleChange({ target: { name: fieldName, value: e.currentTarget.value } });
          if (onChangeCallback) {
            onChangeCallback(e);
          }
        }}
        onBlur={handleBlur}
        type="text"
        as={asTextarea}
      />
      <Form.Text className="text-muted">
        {formText}
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {getIn(errors, fieldName)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
export default TextField;
